<template>
  <div
    class="sc_search_select"
    :class="{ 'disabled-select': disabled }"
    v-click-outside="turnOffSelect"
  >
    <div class="group_search_select">
      <button
        type="button"
        class="button_drop_search"
        :class="[{ active: isShow }]"
        @click="toggleSelect()"
        @keydown="onTriggerKeydown"
        :aria-expanded="isShow ? 'true' : 'false'"
        aria-haspopup="listbox"
        :aria-disabled="disabled ? 'true' : 'false'"
        :disabled="disabled"
        ref="trigger"
      >
        <slot name="label_selected" v-if="customLabel" :selected="value"></slot>
        <span v-else v-html="label"></span>
        <i class="icon-arrow1"></i>
      </button>

      <div class="box_list_search_select active" v-show="isShow">
        <ul
          class="list_search_select"
          role="listbox"
          :aria-activedescendant="activeDescId"
        >
          <li>
            <div class="group-search-input" v-show="searchable">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M11.4994 6.99941C11.4994 7.59035 11.383 8.17552 11.1568 8.72148C10.9307 9.26745 10.5992 9.76352 10.1814 10.1814C9.76352 10.5992 9.26745 10.9307 8.72148 11.1569C8.17552 11.383 7.59036 11.4994 6.99941 11.4994C6.40846 11.4994 5.8233 11.383 5.27733 11.1569C4.73137 10.9307 4.23529 10.5992 3.81743 10.1814C3.39956 9.76352 3.0681 9.26745 2.84195 8.72148C2.6158 8.17552 2.49941 7.59035 2.49941 6.99941C2.49941 5.80593 2.97351 4.66134 3.81743 3.81743C4.66134 2.97351 5.80593 2.49941 6.99941 2.49941C8.19288 2.49941 9.33747 2.97351 10.1814 3.81743C11.0253 4.66134 11.4994 5.80593 11.4994 6.99941ZM10.6794 11.7394C9.47379 12.6754 7.95678 13.1167 6.43721 12.9735C4.91764 12.8304 3.50975 12.1135 2.50016 10.9688C1.49056 9.82412 0.955164 8.3377 1.00294 6.81216C1.05073 5.28661 1.67811 3.83661 2.75736 2.75736C3.83662 1.67811 5.28661 1.05073 6.81216 1.00294C8.33771 0.955161 9.82412 1.49056 10.9688 2.50016C12.1135 3.50975 12.8304 4.91764 12.9735 6.43721C13.1167 7.95677 12.6754 9.47378 11.7394 10.6794L14.7794 13.7194C14.8531 13.7881 14.9122 13.8709 14.9532 13.9629C14.9942 14.0549 15.0162 14.1542 15.018 14.2549C15.0198 14.3556 15.0012 14.4556 14.9635 14.549C14.9258 14.6424 14.8696 14.7272 14.7984 14.7984C14.7272 14.8697 14.6424 14.9258 14.549 14.9635C14.4556 15.0012 14.3556 15.0198 14.2549 15.018C14.1542 15.0162 14.0548 14.9942 13.9629 14.9532C13.8709 14.9122 13.7881 14.8531 13.7194 14.7794L10.6794 11.7394Z"
                  fill="#C7CBD3"
                />
              </svg>
              <input
                autocomplete="off"
                name="search-term"
                placeholder="Search"
                type="text"
                class="form-control"
                v-model="searchTerm"
                :disabled="disabled"
                ref="searchInput"
                @keydown="onSearchKeydown"
              />
            </div>
          </li>

          <li
            v-for="(option, idx) in filteredOptions"
            :key="optionKey(option, idx)"
            role="none"
          >
            <button
              type="button"
              class="full_name_coin_select"
              @click="select(option)"
              role="option"
              :id="optionId(idx)"
              :aria-selected="idx === focusedIndex ? 'true' : 'false'"
              ref="opt"
              @keydown="onOptionKeydown($event, idx)"
            >
              <slot v-if="customLabel" name="option" :option="option"></slot>
              <span v-else v-html="getSelectedValue(option)"></span>
            </button>
          </li>

          <li v-if="filteredOptions.length === 0">
            {{ $t("common.datatable.no_data2") }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    placeholder: { type: String },
    customLabel: { type: Boolean, default: false },
    options: { type: Array, default: () => [] },
    disabled: { type: Boolean, default: false },
    value: { default: "" },
    searchable: { default: false },
  },
  data() {
    return {
      isShow: false,
      searchTerm: "",
      filteredOptions: this.options,
      focusedIndex: -1,
    };
  },
  computed: {
    label() {
      const selected = this.getSelectedValue(this.value);
      return selected || this.placeholder;
    },
    activeDescId() {
      return this.focusedIndex >= 0 ? this.optionId(this.focusedIndex) : null;
    },
  },
  watch: {
    options() {
      this.filteredOptions = this.options;
    },
    searchTerm(st) {
      const q = (st || "").toString();
      this.filteredOptions = this.options.filter((option) => {
        const text = (this.getSelectedValue(option) || "").toString();
        return this.includes(text, q);
      });
      this.resetFocusAfterFilter();
    },
  },
  methods: {
    optionKey(option, idx) {
      if (window._.isObject(option)) return option.id != null ? option.id : idx;
      return `${option}-${idx}`;
    },
    optionId(idx) {
      return `ss_opt_${idx}`;
    },
    toggleSelect() {
      if (this.disabled) return;
      const next = !this.isShow;
      this.isShow = next;
      this.$nextTick(() => {
        if (next) {
          if (this.searchable && this.$refs.searchInput) {
            this.$refs.searchInput.focus();
          } else {
            this.focusInitial();
          }
        }
      });
    },
    turnOffSelect() {
      this.isShow = false;
      this.focusedIndex = -1;
    },
    select(option) {
      this.$emit("input", option);
      this.turnOffSelect();
      this.$nextTick(() => {
        if (this.$refs.trigger && this.$refs.trigger.focus) {
          this.$refs.trigger.focus();
        }
      });
    },
    getSelectedValue(option) {
      const selected = this.options.find((item) => {
        if (window._.isObject(option)) return item.id === option.id;
        return item === option;
      });
      if (typeof selected !== "undefined") {
        return window._.isObject(option) ? selected.name : selected;
      }
      return null;
    },
    includes(str, query) {
      if (str === undefined) str = "undefined";
      if (str === null) str = "null";
      if (str === false) str = "false";
      const text = str.toString().toLowerCase();
      const value = (query || "").toString().trim().toLowerCase();
      return text.includes(value);
    },
    equalsOption(a, b) {
      if (window._.isObject(a) && window._.isObject(b)) return a.id === b.id;
      return a === b;
    },
    focusInitial() {
      let idx = -1;
      const currentIdx = this.filteredOptions.findIndex((o) =>
        this.equalsOption(o, this.value)
      );
      if (currentIdx >= 0) idx = currentIdx;
      else if (this.filteredOptions.length > 0) idx = 0;
      this.setFocus(idx);
    },
    resetFocusAfterFilter() {
      if (!this.isShow) return;
      if (this.filteredOptions.length === 0) {
        this.focusedIndex = -1;
        return;
      }
      const currentIdx = this.filteredOptions.findIndex((o) =>
        this.equalsOption(o, this.value)
      );
      this.setFocus(currentIdx >= 0 ? currentIdx : 0, true);
    },
    moveFocus(delta) {
      if (this.filteredOptions.length === 0) return;
      let idx = this.focusedIndex;
      if (idx < 0) idx = 0;
      idx =
        (idx + delta + this.filteredOptions.length) %
        this.filteredOptions.length;
      this.setFocus(idx);
    },
    setFocus(idx, silent) {
      this.focusedIndex = idx;
      if (idx < 0) return;
      this.$nextTick(() => {
        const btns = this.$refs.opt || [];
        const el = Array.isArray(btns) ? btns[idx] : btns;
        if (el && el.focus && !silent) el.focus();
      });
    },

    onTriggerKeydown(e) {
      if (this.disabled) return;
      const k = e.key;
      if (k === "ArrowDown" || k === "Down") {
        e.preventDefault();
        if (!this.isShow) {
          this.isShow = true;
          this.$nextTick(() => this.focusInitial());
        } else {
          this.moveFocus(1);
        }
      } else if (k === "ArrowUp" || k === "Up") {
        e.preventDefault();
        if (!this.isShow) {
          this.isShow = true;
          this.$nextTick(() => this.focusInitial());
        } else {
          this.moveFocus(-1);
        }
      } else if (k === "Enter" || k === " ") {
        e.preventDefault();
        this.toggleSelect();
      } else if (k === "Escape" || k === "Esc") {
        if (this.isShow) {
          e.preventDefault();
          this.turnOffSelect();
        }
      }
    },
    onSearchKeydown(e) {
      const k = e.key;
      if (k === "ArrowDown" || k === "Down") {
        e.preventDefault();
        if (this.filteredOptions.length > 0) this.setFocus(0);
      } else if (k === "ArrowUp" || k === "Up") {
        e.preventDefault();
        if (this.filteredOptions.length > 0)
          this.setFocus(this.filteredOptions.length - 1);
      } else if (k === "Escape" || k === "Esc") {
        e.preventDefault();
        this.turnOffSelect();
        this.$nextTick(() => this.$refs.trigger && this.$refs.trigger.focus());
      } else if (k === "Enter") {
        if (this.focusedIndex >= 0 && this.filteredOptions[this.focusedIndex]) {
          e.preventDefault();
          this.select(this.filteredOptions[this.focusedIndex]);
        }
      }
    },
    onOptionKeydown(e, idx) {
      const k = e.key;
      if (k === "ArrowDown" || k === "Down") {
        e.preventDefault();
        this.moveFocus(1);
      } else if (k === "ArrowUp" || k === "Up") {
        e.preventDefault();
        this.moveFocus(-1);
      } else if (k === "Home") {
        e.preventDefault();
        this.setFocus(0);
      } else if (k === "End") {
        e.preventDefault();
        this.setFocus(this.filteredOptions.length - 1);
      } else if (k === "Enter" || k === " ") {
        e.preventDefault();
        const opt = this.filteredOptions[idx];
        if (opt) this.select(opt);
      } else if (k === "Escape" || k === "Esc") {
        e.preventDefault();
        this.turnOffSelect();
        this.$nextTick(() => this.$refs.trigger && this.$refs.trigger.focus());
      } else if (k === "Tab") {
        this.turnOffSelect();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/sass/variables";
.pr-5 {
  padding-right: 5px;
}
::-webkit-scrollbar {
  width: 5px;
}

.disabled-select {
  .group_search_select {
    cursor: not-allowed !important;
    .button_drop_search {
      pointer-events: none;
    }
  }
}

.icon-class {
  .sc_search_select {
    .group_search_select {
      .box_list_search_select {
        min-width: 150px;
        left: 50%;
        transform: translateX(-50%);
        .list_search_select {
          max-height: 150px;
          overflow-y: auto;
        }
      }
    }
  }
}
.icon-type {
  .sc_search_select {
    .group_search_select {
      .box_list_search_select {
        .list_search_select {
          max-height: 150px;
          overflow-y: auto;
        }
      }
    }
  }
}

.sc_search_select {
  .tit_search_select {
    font-size: $font-title-size-big;
    color: $color-white;
    margin-bottom: 20px;
    line-height: 44px;
  }
  .group_search_select {
    position: relative;

    .button_drop_search {
      cursor: pointer;
      height: 27px;
      overflow: hidden;
      line-height: 18px;
      padding: 3px 5px;
      border: 1px solid $color-alto;
      border-radius: 3px;
      background: transparent;
      appearance: none;
      display: flex;
      gap: 8px;
      min-width: fit-content !important;
      width: 100%;
      justify-content: space-between;
      background: #fff;

      span {
        display: block;
        float: left;
        color: $color-grey-dusty;
        font-size: 13px;
        line-height: 18px;
      }
      .icon-arrow1 {
        padding: 4px 0px;
        margin-left: 5px;
        font-size: 11px;
        float: right;
        transition: transform 0.2s ease;
      }
      &.active {
        visibility: visible;
        opacity: 1;
        .icon-arrow1 {
          transform: rotate(180deg);
        }
      }
      &:focus-visible {
        box-shadow: 0 0 0 3px rgba(66, 134, 245, 0.2);
        border-color: #000000;
      }
      &[aria-expanded="true"] {
        border-color: $color-jungle-green;
      }
    }

    .box_list_search_select {
      padding-top: 5px;
      position: absolute;
      display: none;
      width: 100%;
      top: 100%;
      left: 0px;
      z-index: 111;
      float: left;
      visibility: hidden;
      opacity: 0;
      max-height: 470px;
      ul {
        margin: 0;
      }
      &.active {
        display: block;
        visibility: visible;
        opacity: 1;
      }
    }

    .list_search_select {
      background: $background-default;
      box-shadow: 0px 3px 12px rgba(49, 49, 49, 0.51);
      list-style-type: none;
      max-height: 286px;
      overflow-y: auto;
      position: relative;
      padding: 12px 0px;

      &:after {
        bottom: 100%;
        left: 50%;
        border: solid transparent;
        content: " ";
        display: block;
        height: 0;
        width: 0;
        position: absolute;
        pointer-events: none;
        border-color: rgba(136, 183, 213, 0);
        border-bottom-color: $color-white;
        border-width: 5px;
        margin-left: -5px;
      }

      li {
        display: block;
        width: 100%;
        line-height: 20px;
        cursor: pointer;
        padding: 0;
        font-size: $font-root;
        overflow: hidden;

        > button.full_name_coin_select {
          display: block;
          width: 100%;
          text-align: left;
          background: transparent;
          border: 0;
          padding: 3px 10px;
          font: inherit;
          cursor: pointer;
          transition: background-color 0.12s ease, box-shadow 0.12s ease;
          &:hover {
            background: rgba(0, 0, 0, 0.03);
          }
          &:focus,
          &:focus-visible {
            background: rgba($color-jungle-green, 0.1);
            box-shadow: 0 0 0 3px rgba($color-jungle-green, 0.2);
            border-color: #000000;
          }
          &:active {
            background: rgba($color-jungle-green, 0.16);
          }
          &[aria-selected="true"] {
            background: rgba($color-jungle-green, 0.14);
          }
        }
      }
    }
  }

  .group-search-input {
    position: relative;
    svg {
      position: absolute;
      transform: translateY(-50%);
      top: 50%;
      left: 16px;
      width: 16px;
      height: 16px;
    }
    input {
      height: 36px;
      border-radius: 8px !important;
      border: 1px solid rgba(199, 203, 211, 0.5) !important;
      background: rgba(199, 203, 211, 0.15) !important;
      display: flex;
      padding: 9px 16px 9px 40px;
      align-items: center;
      gap: 8px;
      flex: 1 0 0;
      color: #c7cbd3;
      font-size: $font_root;
      font-family: $mulish-medium;
      font-weight: 500;

      &::placeholder {
        color: #c7cbd3;
      }
    }
  }
}
</style>
